if (!customElements.get('color-swatches')) {
  customElements.define('color-swatches', class extends HTMLElement {
    connectedCallback() {
      if (this._init) return; this._init = true;
      this.links = Array.from(this.querySelectorAll('.cs__link'));
      this.img = this.resolveImg();
      if (this.img) { this.src0 = this.img.getAttribute('src'); this.srcset0 = this.img.getAttribute('srcset'); }
      this.mode = this.dataset.mode;
      if (this.mode === 'pack') { this.initPack(); } else { this.initSwap(); }
      this.initScrollers();
    }
    /* ---- scrollable swatch rows: arrow buttons + auto-center the active
            swatch on load so it's visible without the shopper scrolling ---- */
    initScrollers() {
      this.querySelectorAll('.cs__row').forEach((row) => {
        const list = row.querySelector('.cs__list');
        const prev = row.querySelector('.cs__arrow--prev');
        const next = row.querySelector('.cs__arrow--next');
        if (!list || !prev || !next) return;
        const step = () => Math.max(list.clientWidth * 0.7, 60);
        const updateArrows = () => {
          const overflowing = list.scrollWidth > list.clientWidth + 1;
          prev.style.display = overflowing && list.scrollLeft > 0 ? 'flex' : 'none';
          next.style.display = overflowing && list.scrollLeft < list.scrollWidth - list.clientWidth - 1 ? 'flex' : 'none';
        };
        prev.addEventListener('click', (e) => { e.preventDefault(); list.scrollBy({ left: -step(), behavior: 'smooth' }); });
        next.addEventListener('click', (e) => { e.preventDefault(); list.scrollBy({ left: step(), behavior: 'smooth' }); });
        list.addEventListener('scroll', updateArrows, { passive: true });
        const activeLink = list.querySelector('.cs__link.is-active') || list.querySelector('.cs__link');
        this.centerSwatch(list, activeLink, false);
        updateArrows();
      });
    }
    centerSwatch(list, link, smooth) {
      if (!list || !link) return;
      const target = link.offsetLeft - (list.clientWidth / 2) + (link.clientWidth / 2);
      const max = list.scrollWidth - list.clientWidth;
      const clamped = Math.max(0, Math.min(target, max));
      if (smooth) list.scrollTo({ left: clamped, behavior: 'smooth' });
      else list.scrollLeft = clamped;
    }
    resolveImg() {
      const scope = this.closest('.card-wrapper, .card, [data-product-card], .grid__item, li') || document;
      const sel = this.dataset.targetSelector;
      if (sel) return scope.querySelector(sel) || document.querySelector(sel);
      const media = scope.querySelector('.media--hover-effect');
      // always Dawn's FIRST/primary image (the one shown at rest)
      if (media && media.querySelector('img')) return media.querySelector('img');
      return scope.querySelector('[data-swatch-target]') || scope.querySelector('.card__media img, .card-wrapper img, img');
    }
    setImg(url) {
      if (!this.img || !url) return;
      if (this.img.hasAttribute('srcset')) this.img.setAttribute('srcset', '');
      this.img.setAttribute('src', url);
    }
    /* ---- keep the card's photo + title links pointed at whichever color is
            currently selected, not the product's default/first variant ---- */
    updateLinks(url) {
      if (!url) return;
      const scope = this.closest('.card-wrapper, .card, [data-product-card], .grid__item, li') || document;
      scope.querySelectorAll('a.card__media, a.full-unstyled-link').forEach((a) => { a.setAttribute('href', url); });
    }
    /* ---- keep the "+N" overflow link (pack mode) pointed at the currently
            selected pairing, so shoppers land on that exact combo on the PDP ---- */
    updateMoreLinks(url) {
      if (!url) return;
      this.querySelectorAll('.cs__more-link').forEach((a) => { a.setAttribute('href', url); });
    }
    activate(link) {
      const list = link.closest('.cs__list');
      list.querySelectorAll('.cs__link').forEach((x) => x.classList.toggle('is-active', x === link));
    }
    /* ---- single color: click selects (main image); hover the IMAGE shows
            the selected color's hover image; swatch hover does nothing ---- */
/* ---- single color: click commits color (updates BOTH main + hover img);
            hover handled natively by Dawn's .media--hover-effect CSS ---- */
    initSwap() {
      this.selected = this.links.find((l) => l.classList.contains('is-active')) || this.links[0];
      const media = this.img && this.img.closest('.media--hover-effect');
      this.hoverImg = media ? media.querySelector('[data-swatch-hover-target]') : null;
      this.commit(this.selected);
      this.links.forEach((l) => l.addEventListener('click', (e) => this.onPickSwap(e, l)));
    }
    setImgEl(el, url) {
      if (!el || !url) return;
      el.removeAttribute('srcset');
      el.removeAttribute('sizes');
      el.src = url;
    }
    commit(link) {
      if (!link) return;
      this.selected = link;
      this.activate(link);
      const main = link.dataset.mainUrl || this.src0;
      const hover = link.dataset.hoverUrl || main;
      this.setImgEl(this.img, main);        // resting image
      this.setImgEl(this.hoverImg, hover);  // Dawn shows this on hover
      this.updateLinks(link.getAttribute('href'));
    }
    onPickSwap(e, link) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
      if (link.classList.contains('is-active')) return; // second click navigates via href
      e.preventDefault();
      this.commit(link);
      this.centerSwatch(link.closest('.cs__list'), link, true);
    }
    /* ---- pack: click non-active = preview pairing; click active = navigate ---- */
    initPack() {
      try { this.map = JSON.parse(this.querySelector('.cs__data').textContent); } catch (e) { this.map = {}; }
      this.selA = this.dataset.initialA || '';
      this.selB = this.dataset.initialB || '';
      this.syncUrl();
      // On load, make the card image + links match the initially-selected pairing
      if (this.imgUrl) this.setImg(this.imgUrl);
      if (this.url) { this.updateLinks(this.url); this.updateMoreLinks(this.url); }
      this.links.forEach((l) => {
        if (l.classList.contains('cs__more-link')) return; // plain navigational link -- not a color pick
        l.addEventListener('click', (e) => this.onPick(e, l));
      });
    }
    syncUrl() {
      const entry = this.map[this.selA + '|||' + this.selB];
      this.url = entry ? entry.url : null;
      this.imgUrl = entry ? entry.img : null;
    }
    onPick(e, link) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return; // let it navigate
      const alreadyActive = link.classList.contains('is-active');
      e.preventDefault();
      if (alreadyActive) {
        if (this.url) window.location.href = this.url;
        return;
      }
      const testA = link.dataset.axis === 'a' ? link.dataset.value : this.selA;
      const testB = link.dataset.axis === 'b' ? link.dataset.value : this.selB;
      const entry = this.map[testA + '|||' + testB];
      if (!entry) return; // that pairing isn't a real, sellable variant -- ignore the click
      this.selA = testA; this.selB = testB;
      this.activate(link);
      this.centerSwatch(link.closest('.cs__list'), link, true);
      this.url = entry.url;
      this.imgUrl = entry.img;
      this.setImg(this.imgUrl);
      link.setAttribute('href', this.url);
      this.updateLinks(this.url);
      this.updateMoreLinks(this.url);
    }
  });
}
